import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, RocketIcon, LifeBuoyIcon, FolderIcon, ClockIcon, ClipboardCheckIcon, CheckIcon } from 'lucide-react';
const tomos = [{
  n: 'Tomo 1',
  title: 'El Motor de Planificación',
  desc: 'Sistema 3T · 28 minutos · Toda la semana lista.',
  Icon: RocketIcon,
  color: 'text-brandpurple',
  bg: 'bg-brandpurple/10'
}, {
  n: 'Tomo 2',
  title: 'Banco de Inicio y Cierre',
  desc: '100 inicios · 100 cierres · Nunca en blanco.',
  Icon: BookOpenIcon,
  color: 'text-teal',
  bg: 'bg-teal/10'
}, {
  n: 'Tomo 3',
  title: 'Unidades de Supervivencia',
  desc: '12 proyectos · Lunes 7AM → clase a las 8:05.',
  Icon: LifeBuoyIcon,
  color: 'text-magenta',
  bg: 'bg-magenta/10'
}, {
  n: 'Tomo 4',
  title: 'El Archivador de Fichas',
  desc: '50 fichas · Cualquier materia · Sin editar.',
  Icon: FolderIcon,
  color: 'text-navy',
  bg: 'bg-navy/10'
}, {
  n: 'Tomo 5',
  title: 'Gestión de Aula y Tiempo',
  desc: 'Rutinas en 14 días · 0 mensajes de padres los domingos.',
  Icon: ClockIcon,
  color: 'text-brandpurple',
  bg: 'bg-brandpurple/10'
}, {
  n: 'Tomo 6',
  title: 'Evaluación Invisible',
  desc: '30 alumnos evaluados en 15 minutos · Sin llevar nada a casa.',
  Icon: ClipboardCheckIcon,
  color: 'text-magenta',
  bg: 'bg-magenta/10'
}];
const includes = ['Listo para usar mañana sin editar', 'Funciona sin tecnología ni proyector', 'Adaptable a cualquier país de habla hispana', 'Versión para todos los niveles educativos', 'Un solo pago · 40 semanas resueltas'];
export function Tomos() {
  return <section className="bg-navy px-4 py-16 text-white" data-id="element-214">
      <div className="mx-auto max-w-4xl text-center" data-id="element-215">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-white/80" data-id="element-216">
          🏆 Método Domingo Libre™
        </span>
        <h2 className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-217">
          De 6 horas de angustia dominical a{' '}
          <span className="italic text-magenta" data-id="element-218">28 minutos</span>.
        </h2>
        <p className="mt-3 text-white/70" data-id="element-219">Empezando este domingo.</p>

        <p className="mt-8 text-sm font-bold uppercase tracking-widest text-white/60" data-id="element-220">
          6 tomos completos
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-221">
        {tomos.map((t, i) => <motion.div key={t.n} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.06
      }} className="flex items-start gap-4 rounded-2xl bg-white p-5 text-navy shadow-soft" data-id="element-222">
            <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${t.bg}`} data-id="element-223">
              <t.Icon className={`h-6 w-6 ${t.color}`} data-id="element-224" />
            </div>
            <div data-id="element-225">
              <div className="text-xs font-bold uppercase tracking-wide text-magenta" data-id="element-226">
                {t.n}
              </div>
              <h3 className="font-display text-lg font-black leading-tight text-navy" data-id="element-227">
                {t.title}
              </h3>
              <p className="mt-1 text-sm text-navy/65" data-id="element-228">{t.desc}</p>
            </div>
          </motion.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-white/15 bg-white/5 p-6" data-id="element-229">
        <p className="mb-4 text-center text-sm font-bold uppercase tracking-wide text-white/70" data-id="element-230">
          Cada tomo incluye:
        </p>
        <ul className="grid gap-2.5 sm:grid-cols-2" data-id="element-231">
          {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm" data-id="element-232">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" data-id="element-233" />
              <span className="text-white/85" data-id="element-234">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}